import { RFIconProps } from "../types";

export default function UserIcon(props: RFIconProps) {
	return (
		<svg width="14" height="15" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
			<path
				d="M7.00457 7.5228C8.52965 7.5228 9.76597 6.28648 9.76597 4.7614C9.76597 3.23632 8.52965 2 7.00457 2C5.47949 2 4.24316 3.23632 4.24316 4.7614C4.24316 6.28648 5.47949 7.5228 7.00457 7.5228Z"
				stroke="currentColor"
				strokeWidth={props.strokeWidth || 1.5}
				strokeMiterlimit="10"
			/>
			<path
				d="M7.00441 13.1603H2.46089C2.39675 13.1606 2.33325 13.1474 2.27451 13.1217C2.21576 13.0959 2.16308 13.0581 2.11984 13.0107C2.07661 12.9633 2.0438 12.9074 2.02352 12.8466C2.00325 12.7857 1.99596 12.7213 2.00213 12.6574C2.11917 11.4129 2.69631 10.2569 3.62065 9.41538C4.54498 8.5739 5.75001 8.10754 7 8.10754C8.24999 8.10754 9.45502 8.5739 10.3794 9.41538C11.3037 10.2569 11.8808 11.4129 11.9979 12.6574C12.004 12.7213 11.9968 12.7857 11.9765 12.8466C11.9562 12.9074 11.9234 12.9633 11.8802 13.0107C11.8369 13.0581 11.7842 13.0959 11.7255 13.1217C11.6667 13.1474 11.6033 13.1606 11.5391 13.1603H7.00441Z"
				stroke="currentColor"
				strokeWidth={props.strokeWidth || 1.5}
				strokeMiterlimit="10"
			/>
		</svg>
	);
}
